import { render } from "./HeaderLabel.vue?vue&type=template&id=f436d9ca&lang=pug"
import script from "./HeaderLabel.vue?vue&type=script&lang=js"
export * from "./HeaderLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__